// Copyright ©️ 2025 eVolve MEP, LLC

import type { RenderableUser } from '@evolvemep/api-ts';

import type { StrongOmit } from './helper-types';
import { isNil } from './isNotNil';

export const validateUserNameOrEmail = (
  user: StrongOmit<RenderableUser, 'userId'> | undefined | null,
  trimEmail = false,
): string => {
  if (isNil(user)) {
    return '';
  }
  // TODO: Once all User endpoints return `RenderableUser`, just always use that
  if (user.nameOrEmail && !trimEmail) return user.nameOrEmail;
  if (user.userFirstName && user.userLastName) return `${user.userFirstName} ${user.userLastName}`;
  return user.userFirstName ?? (trimEmail ? user.userEmail.split('@')[0] : user.userEmail) ?? '';
};
